"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var deviceAtmosphereEnabledKpi_type_1 = require("./deviceAtmosphereEnabledKpi.type");
var PREFIX_RUBIX = "RU_XX_01_";
var PREFIX_GIGACONCPET_E4000 = "GC_E4_01_";
var PREFIX_GIGACONCPET_ERSC02 = "GC_EC_01_";
var PREFIX_TESTO_IAQ = "TE_IAQ_160_";
exports.isRubix = function (deviceId) { return deviceId.startsWith(PREFIX_RUBIX); };
exports.isGCE4000 = function (deviceId) { return deviceId.startsWith(PREFIX_GIGACONCPET_E4000); };
exports.isGCERSC02 = function (deviceId) { return deviceId.startsWith(PREFIX_GIGACONCPET_ERSC02); };
exports.isTestoIAQ = function (deviceId) { return deviceId.startsWith(PREFIX_TESTO_IAQ); };
exports.isAtmosphereDevice = function (deviceId) { return exports.isRubix(deviceId) || exports.isGCE4000(deviceId) || exports.isGCERSC02(deviceId) || exports.isTestoIAQ(deviceId); };
exports.isDeviceRubix = function (device) { return exports.isRubix(device.id); };
exports.isDeviceGCE4000 = function (device) { return exports.isGCE4000(device.id); };
exports.isDeviceGCERSC02 = function (device) { return exports.isGCERSC02(device.id); };
exports.isDeviceTestoIAQ = function (device) { return exports.isTestoIAQ(device.id); };
exports.availableKpiTypeByDevice = function (deviceId) {
    var DEFAULT_KPIS = [deviceAtmosphereEnabledKpi_type_1.KpiAtmosphereTypes.CO2, deviceAtmosphereEnabledKpi_type_1.KpiAtmosphereTypes.HUMIDITY, deviceAtmosphereEnabledKpi_type_1.KpiAtmosphereTypes.TEMPERATURE];
    if (exports.isRubix(deviceId)) {
        return __spread(DEFAULT_KPIS);
    }
    if (exports.isGCE4000(deviceId)) {
        return __spread(DEFAULT_KPIS, [deviceAtmosphereEnabledKpi_type_1.KpiAtmosphereTypes.LUMINOSITY]);
    }
    if (exports.isGCERSC02(deviceId)) {
        return __spread(DEFAULT_KPIS, [deviceAtmosphereEnabledKpi_type_1.KpiAtmosphereTypes.COV]);
    }
    if (exports.isTestoIAQ(deviceId)) {
        return DEFAULT_KPIS;
    }
    return DEFAULT_KPIS;
};
